export default {
  dent: "DAMAGE_TYPE_DENT",
  bump: "DAMAGE_TYPE_BUMP",
  scratch: "DAMAGE_TYPE_SCRATCH",
  polish: "DAMAGE_TYPE_POLISH",
  rim: "DAMAGE_TYPE_RIM"
};
